import { DefineGetters } from "vuex-type-helper";
import { ImportGetters, ImportState } from "./types";

export const getters: DefineGetters<ImportGetters, ImportState> = {
  getTotalRecords: ({ links, imports }: ImportState) =>
    links && links.totalRecords ? links.totalRecords : imports.length,
  getImportById: (state: ImportState) => (id: string) =>
    state.imports.find((importData: any) => importData._id === id)
};
